module.exports = __webpack_public_path__ + "img/volume_on.59161608.svg";